module.exports = __webpack_public_path__ + "officialStatic/img/studentA.2a8fc1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/studentA.png
// module id = hQZG
// module chunks = 0